<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>{{ header }} Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="closeDialog">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-flex xs12>
          <v-card>
            <v-card-text>
              <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
              <v-data-table
                v-bind:headers="headers"
                v-bind:items="items"
                v-bind:search="search"
                :footer-props="{'items-per-page-options': itemsPerPage }"
                v-bind:options.sync="pagination"
                item-key="id"
                :loading="loading"
                :no-data-text="noDataText"
                :custom-filter="customSearch"
                v-model="selected"
              >
                <template v-slot:item="row"
                  ><tr>
                    <td style="width: 50px">
                      <v-checkbox primary hide-details v-model="row.selected" @change="collectItems($event, row.item.id)"></v-checkbox>
                    </td>
                    <td class="text-xs-left">{{ row.item.id }}</td>
                    <td class="text-xs-left">{{ row.item.desc }}</td>
                  </tr>
                </template>
              </v-data-table>
              <div v-if="checkedItems.length === 0 && isDefAll" class="small font-weight-light grey--text">
                Note: Default is "All" if no item is selected.
              </div>
              <v-textarea v-if="checkedItems.length > 0" label="Selected Items" v-model="checkedItems" rows="1" readonly></v-textarea>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="green" dark class=" mr-2" @click="doSelect('All', header)">
                Select All
                <v-icon right>mdi-check-all</v-icon>
              </v-btn>
              <v-btn color="info" dark class=" mr-2" @click.prevent="doReset">
                Reset
                <v-icon dark right>mdi-refresh</v-icon></v-btn
              >
              <v-btn color="primary" dark class=" mr-2" @click="doSelect('', header)">
                Select
                <v-icon right>mdi-check</v-icon>
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as TableConst from '@/mixins/table'
import { helpListMixin } from '@/mixins/common/helpListMixin'
import MessageMixin from '@/mixins/message'

export default {
  props: {
    defAll: Boolean,
    boolRefresh: Boolean,
    param: String
  },
  data() {
    return {
      headers: [
        { text: '', value: 'id' },
        { text: 'Transaction Type', value: 'id' },
        { text: 'Description', value: 'desc' }
      ],
      tranTypeList: [
        { text: 'Debit Note', value: 'W' },
        { text: 'Credit Note', value: 'X' },
        { text: 'Receipt', value: 'Y' },
        { text: 'Payment Voucher', value: 'Z' }
      ],
      header: 'Transaction Type',
      selected: [],
      parameter: [],
      items: [],
      isDefAll: false,
      totalItems: 0,
      selectedItems: [],
      checkedItemsAll: [],
      checkedItems: [],
      pagination: {
        sortDesc: [false],
        page: 1
      }
    }
  },
  created() {
    this.doInit()
  },
  watch: {
    boolRefresh: function (value) {
      this.doInit()
    }
  },
  methods: {
    doInit() {
      this.items = []
      this.parameter = []
      this.isDefAll = this.defAll
      /*
      if (this.param !== null && this.param !== '') {
        this.parameter = this.param.split(',')
      }
      if (this.parameter !== this.checkedItems) {
        this.doReset()
        this.checkedItems = this.parameter
      }
      */
      this.selectedItems = []
      const data = this.tranTypeList
      if (data) {
        data.filter((list) => {
          this.items.push({ id: list.value, desc: list.text })
          if (this.checkedItems.includes(list.value)) {
            const tranTypeList = {
              id: list.value,
              desc: list.text
            }
            this.selectedItems.push(tranTypeList)
          }
        })
      }
      if (this.checkedItems.toString() === 'All') {
        this.doReset()
        this.toggleAll()
      } else {
        this.toggleSelected()
      }
    },
    collectItems(event, item) {
      if (event) {
        if (this.checkedItems.toString() === 'All') {
          this.doReset()
        }
        this.checkedItems.push(item)
        this.checkedItems.sort()
      } else {
        this.checkedItems.splice(this.checkedItems.indexOf(item), 1)
        this.checkedItems.sort()
      }
    },
    toggleAll() {
      this.doReset()
    },
    toggleSelected() {
      this.selected = this.selectedItems.slice()
    },
    doReset() {
      this.checkedItems = []
      this.selected = []
      this.checkedItemsAll = []
    },
    doSelect(opt, caller) {
      let selectedObj = {}
      if (opt === 'All') {
        this.doReset()
        this.checkedItemsAll.push('All')
        selectedObj = {
          finalSelectedItems: this.checkedItemsAll
        }
      } else {
        if (this.checkedItems.length === 0 && this.isDefAll === true) {
          selectedObj = {
            finalSelectedItems: ['All']
          }
        } else {
          selectedObj = {
            finalSelectedItems: this.checkedItems
          }
        }
      }
      this.$emit('doAssignTranType', selectedObj)
      this.$emit('close', caller)
    },
    closeDialog() {
      this.$emit('close')
    }
  },
  mixins: [TableConst.default, MessageMixin, helpListMixin]
}
</script>

<style>
</style>
